var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 3.33341C6.81818 3.33341 3.83341 6.31818 3.83341 10.0001C3.83341 13.682 6.81818 16.6667 10.5001 16.6667C14.182 16.6667 17.1667 13.682 17.1667 10.0001C17.1667 6.31818 14.182 3.33341 10.5001 3.33341ZM2.16675 10.0001C2.16675 5.39771 5.89771 1.66675 10.5001 1.66675C15.1025 1.66675 18.8334 5.39771 18.8334 10.0001C18.8334 14.6025 15.1025 18.3334 10.5001 18.3334C5.89771 18.3334 2.16675 14.6025 2.16675 10.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07733 6.91083C9.40277 6.58539 9.9304 6.58539 10.2558 6.91083L12.7558 9.41083C13.0813 9.73626 13.0813 10.2639 12.7558 10.5893L10.2558 13.0893C9.9304 13.4148 9.40277 13.4148 9.07733 13.0893C8.75189 12.7639 8.75189 12.2363 9.07733 11.9108L10.9881 10.0001L9.07733 8.08934C8.75189 7.7639 8.75189 7.23626 9.07733 6.91083Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowRight);
export default __webpack_public_path__ + "static/media/circle-arrow-right.7bf2bc201832f4fa5f420cf6ff7da9fa.svg";
export { ForwardRef as ReactComponent };